module.exports = __webpack_public_path__ + "img/head-office.091358c7.jpg";